import React, { useRef, useState } from 'react';
import ScrollableArea from '../../scrollbar/ScrollableArea';
import StripedTable from '../../StripedTable/StripedTable';
import EventCalendarTableHead from './EventCalendarTableHead';
import EventCalendarTableBody from './EventCalendarTableBody';

const EventCalendarTable = ({ 
    columnDefinitions,
    data,
    onDeleteAllClick,
    onDeleteClick,
    dateFormat,
    id = 'event-calendar'
}) => {
    const [scrollPx, setScrollPx] = useState(0);

    const containerRef = useRef(null);
    const scrollableRef = useRef(null);
    const tableRef = useRef(null);
    const tableHeadRef = useRef(null);

    const border = '1px solid #D7D7D7';

    return (
        <ScrollableArea
            id={`${id}-container`}
            ref={containerRef}
            style={{ width: '100%' }}
            scrollSpeed={8}
            scrollPx={scrollPx}
            onScroll={setScrollPx}
            scrollableLength={scrollableRef?.current?.scrollHeight}
            maxVisibleLength={containerRef?.current?.clientHeight}
        >
            <StripedTable
                id={`table-striped-${id}`}
                ref={tableRef}
                style={{ width: '100%' }}
            >
                <EventCalendarTableHead
                    id={id}
                    ref={tableHeadRef}
                    border={border}
                    definitions={columnDefinitions}
                    onDeleteAllClick={onDeleteAllClick}
                />
                <EventCalendarTableBody
                    id={id}
                    ref={scrollableRef}
                    scrollPx={scrollPx}
                    onScroll={setScrollPx}
                    tableOffsetTop={tableRef?.current?.offsetTop}
                    maxHeight={300}
                    border={border}
                    columnDefinitions={columnDefinitions}
                    data={data}
                    onDeleteClick={onDeleteClick}
                    dateFormat={dateFormat}
                />
            </StripedTable>
        </ScrollableArea>
    )

};

export default EventCalendarTable;
